import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { insertReturnStockDataApi } from "src/api/commonapi";
import { notification } from "src/utils/messages";
import { useRealUser } from "../CityStockReport/CityStockContext";

export default function ReturnProductModal({
  returnProductModal,
  toggleReturnProductModal,
  rowData,
  handleGetProducts,
  filterData
}) {
  const user = useRealUser();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [returnProductData, setReturnProductData] = useState({
    qty: "",
    date: new Date(),
    reason: "",
    p_id: rowData.p_id,
    city_id: rowData.city_id,
    p_name: rowData.p_name,
    city_name: rowData.city_name,
    attachments: [] // 👈 multiple files
  });
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleInsertReturnStock = async () => {
    if (
      returnProductData.qty !== "" &&
      returnProductData.date !== "" &&
      returnProductData.reason !== ""
    ) {
      setLoader(true);
      const formData = new FormData();

      formData.append("qty", returnProductData.qty);
      formData.append("date", moment(returnProductData.date).format("DD-MM-YYYY"));
      formData.append("reason", returnProductData.reason);
      formData.append("p_id", returnProductData.p_id);
      formData.append("city_id", returnProductData.city_id);
      formData.append("u_id", user?.u_id);
      formData.append("u_name", user?.name);

      // 👇 append multiple files
      returnProductData.attachments.forEach((file) => {
        formData.append("stock_return_attachment", file);
      });

      setIsLoading(true);
      const resp = await insertReturnStockDataApi(formData);
      setIsLoading(false);
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status != 0) {
        toggleReturnProductModal();
        handleGetProducts(filterData);
      }
      setLoader(false);
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={returnProductModal}
      onClose={() => toggleReturnProductModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {/* {modalType} New Stock */}
          {rowData.p_name}
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid
              item
              sm={12}
              xs={12}
              md={6}
              lg={6}
              style={{ marginBottom: "15px", marginTop: "15px" }}
            >
              <TextField
                fullWidth
                autoComplete="off"
                type="number"
                label="Quantity"
                name="p_qty"
                required
                size="small"
                placeholder="Enter Quantity"
                onChange={(e) => {
                  setReturnProductData({
                    ...returnProductData,
                    qty: e.target.value
                  });
                }}
                value={returnProductData?.qty}
              />
            </Grid>
            <Grid item xs={6}>
              <Stack spacing={3} style={{ marginBottom: "15px", marginTop: "15px" }}>
                {/* <label style={{ marginBottom: '10px' }}>Join Date</label> */}
                <LocalizationProvider
                  dateAdapter={AdapterDateFns}
                  isDisabled
                  style={{ marginTop: "15px" }}
                >
                  <DatePicker
                    type="date"
                    name="date"
                    label="Date"
                    value={
                      returnProductData.date ? moment(returnProductData.date).toDate() : new Date()
                    }
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setReturnProductData({
                        ...returnProductData,
                        date: moment(newDate).format("YYYY-MM-DD")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40
                          },
                          "& .MuiInputLabel-root": {
                            top: "-6px" // adjust this to move label vertically
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>

            <Grid item sm={12} xs={12} md={12} lg={12} style={{ marginBottom: "15px" }}>
              <TextField
                fullWidth
                autoComplete="off"
                type="text"
                label="Reason"
                name="reason"
                required
                size="small"
                placeholder="Enter Reason"
                onChange={(e) => {
                  setReturnProductData({
                    ...returnProductData,
                    reason: e.target.value
                  });
                }}
                value={returnProductData?.reason}
              />
            </Grid>
            <Grid item xs={4} style={{ marginBottom: "15px" }}>
              <label>Attachments *</label>

              {returnProductData.attachments.length > 0 && (
                <Box mt={1}>
                  {returnProductData.attachments.map((file, index) => (
                    <Typography key={index} fontSize={14}>
                      {file.name}
                    </Typography>
                  ))}
                </Box>
              )}

              <Stack direction="row" alignItems="center" spacing={2} mt={1}>
                <Button variant="contained" component="label" sx={{ height: 40 }}>
                  Upload Files
                  <input
                    type="file"
                    hidden
                    multiple
                    accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf"
                    onChange={(event) => {
                      setReturnProductData({
                        ...returnProductData,
                        attachments: Array.from(event.target.files)
                      });
                    }}
                  />
                </Button>
              </Stack>
            </Grid>
            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleReturnProductModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleInsertReturnStock()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
